<template>
  <div id="buc__users-panel">
    <div id="buc__my-profile-cont">
      <div class="buc__wrap">
        <img
          @click="showStatus = !showStatus" 
          v-click-outside="hideStatusTray"
          :src="my_profile.avatar_url"
          :class="profileStatusClass"
          alt
        />
        <span class="buc__my-info">          
          <p>{{my_profile.fullname}}</p>
          <p class="buc__italic">{{label[currentStatus]}}</p>
        </span>
        <span class="buc__icon buc__right" @click="showUserMenu = !showUserMenu">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><defs/><circle cx="256" cy="256" r="64"/><circle cx="256" cy="448" r="64"/><circle cx="256" cy="64" r="64"/></svg>
        </span>

        <div id="buc__user-settings" v-if="showUserMenu">
          <ul>
            <li>              
              <label class="buc__sound-checkbox">{{label.sound}}
                <input type="checkbox" v-model="isSoundOn" @click="toggleSound">
                <span class="buc__sound-checkmark"></span>
              </label>            
            </li>
          </ul>
        </div>

        <div id="buc__status-options" :class="{buc__active : showStatus}">
          <ul>
            <li @click="setStatus('online')" :class="{buc__active : currentStatus == 'online'}" id="buc__status-online"><span class="buc__status-circle"></span> <p>{{label.online}}</p></li>
            <li @click="setStatus('away')" :class="{buc__active : currentStatus == 'away'}" id="buc__status-away"><span class="buc__status-circle"></span> <p>{{label.away}}</p></li>
            <li @click="setStatus('busy')" :class="{buc__active : currentStatus == 'busy'}" id="buc__status-busy"><span class="buc__status-circle"></span> <p>{{label.busy}}</p></li>
            <li @click="setStatus('offline')" :class="{buc__active : currentStatus == 'offline'}" id="buc__status-offline"><span class="buc__status-circle"></span> <p>{{label.offline}}</p></li>
          </ul>
        </div>        
      </div>
    </div>
    <div id="buc__user-search">
      <label for>
        <span class="buc__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448.098 448.098"><defs/><path d="M184.08 0C82.46 0 .08 82.38.08 184s82.38 184 184 184 184-82.38 184-184C367.992 82.416 285.664.088 184.08 0zm0 304c-66.274 0-120-53.726-120-120s53.726-120 120-120 120 53.726 120 120c-.088 66.238-53.762 119.912-120 120zM438.64 393.44l-64-64c-12.504-12.504-32.776-12.504-45.28 0s-12.504 32.776 0 45.28l64 64c12.504 12.504 32.776 12.504 45.28 0s12.504-32.776 0-45.28z"/></svg>
        </span>
      </label>
      <input v-model="searchParam" type="text" :placeholder="label.search" />
    </div>
    <div id="buc__contacts-cont">
      <ul v-if="currentTab == 'friends' && Object.keys(filteredFriend).length">
        <li v-for="(friend, index) in filteredFriend" :key="index" class="buc__contacts-list buc__friends" :class="resolveStatus('' + friend.id)" @click="onChatOpen(friend.id, 0)">
          <div class="buc__wrap">
            <span class="buc__contact-status" :class="resolveStatus('' + friend.id)"></span>
            <img
              v-if="friend.avatar_url"
              alt="Avatar"
              :src="friend.avatar_url"
              @error="(() => friend.avatar_url = null)"
            />
            <img v-else alt="Avatar" :src="plugin_url + 'assets/img/user-img.svg'" />
            <div class="buc__contact-info">
              <p class="buc__contact-name">{{friend.fullname}}</p>
              <p class="buc__contact-last-msg buc__italic">
                {{(friend.user_status == 'online' && (resolveStatus('' + friend.id) == 'away' || resolveStatus('' + friend.id) == 'offline')) ? (label.last_seen_at + ' ' + formatDate(friend.last_active)) : label[friend.user_status] }}
              </p>
            </div>
          </div>
        </li>
      </ul>
      <ul v-else-if="settings.group_chat_enable == '1' && currentTab == 'groups' && Object.keys(filteredGroup).length">
        <li v-for="(group, index) in filteredGroup" :key="index" class="buc__contacts-list" 
        @click="(Object.keys(group.group_join).length && (group.group_join.id == 'join_group' || group.group_join.id == 'accept_invite' || group.group_join.id == 'request_membership' || group.group_join.id == 'membership_requested')) ? null : onChatOpen(group.id, 1)">
          <div class="buc__wrap">
            <img
              v-if="group.avatar_url"
              alt="Avatar"
              :src="group.avatar_url"
              @error="(() => group.avatar_url = null)"
            />
            <img v-else alt="Avatar" :src="plugin_url + 'assets/img/user-img.svg'" />
            <div class="buc__contact-info">
              <p class="buc__contact-name">{{group.group_name}}</p>
              <a class="buc__group-button" v-if="Object.keys(group.group_join).length" :href="group.group_join.link_href">{{group.group_join.link_text.split(" ")[0]}}</a>
              <p class="buc__contact-last-msg buc__italic">
                {{group.group_type + " - " + group.members_count}}
              </p>
            </div>
          </div>
        </li>
      </ul>
      <ul v-else-if="currentTab == 'chats' && filteredChats.length">
        <li v-for="(chat, index) in filteredChats" :key="index" class="buc__contacts-list" @click="onChatOpen(chat.id, chat.is_group)">
          <div class="buc__wrap">
            <span v-if="chat.is_group == 0" class="buc__contact-status" :class="resolveStatus(chat.id)"></span>
            <img
              v-if="chat.is_group == 0 && friends[chat.id].avatar_url"
              alt="Avatar"
              :src="friends[chat.id].avatar_url"
              @error="(() => friends[chat.id].avatar_url = null)"
            />
            <img
              v-else-if="chat.is_group == 1 && groups[chat.id].avatar_url"
              alt="Avatar"
              :src="groups[chat.id].avatar_url"
              @error="(() => groups[chat.id].avatar_url = null)"
            />
            <img v-else alt="Avatar" :src="plugin_url + 'assets/img/user-img.svg'" />
            <div class="buc__contact-info">
              <p class="buc__contact-name">{{chat.fullname}}</p>
              <span v-if="chat.unread_count" class="buc__unread-count" >{{(chat.unread_count > 9) ? '9+' : chat.unread_count}}</span>
              <span :class="['buc__contact-last-msg', 'buc__italic', {'buc__bold' : chat.unread_count}]" v-html="chat.sent_by + ' : ' + chat.last_msg"></span>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="(currentTab == 'chats' && !filteredChats.length) || (currentTab == 'friends' && !Object.keys(filteredFriend).length) || (currentTab == 'groups' && !Object.keys(filteredGroup).length)" id="buc__empty-user-cont">
        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><defs/><g fill-rule="evenodd"><path d="M248.953 61.273c-5.367-1.238-10.723 2.102-11.965 7.47-1.242 5.366 2.106 10.726 7.473 11.968 24.812 5.734 47.492 18.332 65.582 36.422 53.184 53.183 53.184 139.726 0 192.91-53.184 53.187-139.727 53.187-192.91 0-53.188-53.184-53.188-139.727 0-192.91 15.27-15.27 33.34-26.406 53.71-33.11 5.231-1.718 8.079-7.355 6.36-12.59-1.723-5.234-7.363-8.081-12.594-6.359-23.367 7.684-44.086 20.453-61.582 37.953-60.965 60.965-60.965 160.16 0 221.125 30.48 30.48 70.52 45.723 110.563 45.723 40.039-.004 80.078-15.242 110.562-45.723 60.961-60.965 60.961-160.16 0-221.125-20.738-20.734-46.738-35.175-75.199-41.754zm0 0"/><path d="M498.414 432.707L393.883 328.176c53.601-84.055 41.863-194.485-29.266-265.617C324.277 22.219 270.641 0 213.59 0 156.535 0 102.898 22.219 62.559 62.559 22.215 102.899 0 156.535 0 213.589c0 57.052 22.215 110.688 62.559 151.028 40.34 40.34 93.972 62.555 151.023 62.555 40.945 0 80.387-11.485 114.594-33.29l104.531 104.532c8.746 8.75 20.414 13.566 32.856 13.566 12.437 0 24.105-4.816 32.855-13.566 18.11-18.117 18.11-47.59-.004-65.707zm-14.105 51.602c-4.98 4.976-11.637 7.718-18.746 7.718-7.114 0-13.77-2.742-18.75-7.718L336.507 374.004a9.946 9.946 0 00-7.055-2.922c-1.976 0-3.96.582-5.683 1.777-32.41 22.48-70.516 34.364-110.188 34.364-51.723 0-100.348-20.141-136.918-56.711-75.5-75.5-75.5-198.348 0-273.848 36.574-36.574 85.2-56.715 136.926-56.715 51.722 0 100.347 20.14 136.922 56.715 66.281 66.285 75.683 170.207 22.347 247.106a9.97 9.97 0 001.145 12.738l110.305 110.305c10.336 10.335 10.336 27.156 0 37.496zm0 0"/><path d="M273.805 153.371c-3.895-3.894-10.207-3.894-14.106 0l-46.11 46.11-46.112-46.11c-3.895-3.894-10.211-3.894-14.106 0-3.894 3.895-3.894 10.211 0 14.106l46.11 46.113-46.11 46.11c-3.894 3.894-3.894 10.21 0 14.105a9.931 9.931 0 007.05 2.922 9.94 9.94 0 007.056-2.922l46.109-46.11 46.11 46.11a9.947 9.947 0 007.054 2.922 9.94 9.94 0 007.055-2.922c3.894-3.895 3.894-10.211 0-14.106l-46.114-46.11 46.114-46.112c3.894-3.895 3.894-10.211 0-14.106zm0 0M206.977 77.328c5.492 0 9.972-4.48 9.972-9.976 0-5.493-4.48-9.973-9.972-9.973-5.497 0-9.977 4.48-9.977 9.973 0 5.496 4.48 9.976 9.977 9.976zm0 0"/></g></svg>
        <p>{{currentTab == 'chats' ? label.chats + ' ' + label.not_found : (currentTab == 'friends' ? label.friends + ' ' + label.not_found : label.groups + ' ' + label.not_found)}}</p>
      </div>
    </div>
    <div class="buc__nav-bar">
      <ul>
      <li>
        <a href="javascript:void(0)" @click="currentTab = 'chats'" :class="{buc__active : currentTab == 'chats'}">
          <span class="buc__icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><defs/><path d="M460.747 439.163c75.489-87.071 66.225-218.376-18.944-294.583C485.549 297.874 369.873 451 210.5 451c-3.068 0 15.448.108-57.484-.342C192.905 490.361 246.033 512 301.496 512l195.561-1c13.333-.064 19.975-16.29 10.464-25.677z"/><path d="M210.5 421c116.064 0 210.489-94.43 210.489-210.5S326.565 0 210.5 0 .012 94.43.012 210.5c0 51.099 18.088 99.427 51.237 137.663l-46.774 46.16C-5.005 403.68 1.562 419.935 14.94 420l195.56 1zm-89.495-285h179.99c8.284 0 14.999 6.716 14.999 15s-6.715 15-14.999 15h-179.99c-8.284 0-14.999-6.716-14.999-15s6.716-15 14.999-15zm0 60h179.99c8.284 0 14.999 6.716 14.999 15s-6.715 15-14.999 15h-179.99c-8.284 0-14.999-6.716-14.999-15s6.716-15 14.999-15zm-14.999 75c0-8.284 6.715-15 14.999-15h179.99c8.284 0 14.999 6.716 14.999 15s-6.715 15-14.999 15h-179.99c-8.283 0-14.999-6.716-14.999-15z"/></svg>
          </span>{{label.chats}}
        </a>
      </li>
      <li>
        <a href="javascript:void(0)" @click="currentTab = 'friends'" :class="{buc__active : currentTab == 'friends'}">
          <span class="buc__icon">
            <svg viewBox="-42 0 512 512.002" xmlns="http://www.w3.org/2000/svg"><defs/><path d="M210.352 246.633c33.882 0 63.222-12.153 87.195-36.13 23.973-23.972 36.125-53.304 36.125-87.19 0-33.876-12.152-63.211-36.129-87.192C273.566 12.152 244.23 0 210.352 0c-33.887 0-63.22 12.152-87.192 36.125s-36.129 53.309-36.129 87.188c0 33.886 12.156 63.222 36.133 87.195 23.977 23.969 53.313 36.125 87.188 36.125zm0 0M426.129 393.703c-.692-9.976-2.09-20.86-4.149-32.351-2.078-11.579-4.753-22.524-7.957-32.528-3.308-10.34-7.808-20.55-13.37-30.336-5.774-10.156-12.555-19-20.165-26.277-7.957-7.613-17.699-13.734-28.965-18.2-11.226-4.44-23.668-6.69-36.976-6.69-5.227 0-10.281 2.144-20.043 8.5a2711.03 2711.03 0 01-20.879 13.46c-6.707 4.274-15.793 8.278-27.016 11.903-10.949 3.543-22.066 5.34-33.039 5.34-10.972 0-22.086-1.797-33.047-5.34-11.21-3.622-20.296-7.625-26.996-11.899-7.77-4.965-14.8-9.496-20.898-13.469-9.75-6.355-14.809-8.5-20.035-8.5-13.313 0-25.75 2.254-36.973 6.7-11.258 4.457-21.004 10.578-28.969 18.199-7.605 7.281-14.39 16.12-20.156 26.273-5.558 9.785-10.058 19.992-13.371 30.34-3.2 10.004-5.875 20.945-7.953 32.524-2.059 11.476-3.457 22.363-4.149 32.363A438.821 438.821 0 000 423.949c0 26.727 8.496 48.363 25.25 64.32 16.547 15.747 38.441 23.735 65.066 23.735h246.532c26.625 0 48.511-7.984 65.062-23.734 16.758-15.946 25.254-37.586 25.254-64.325-.004-10.316-.351-20.492-1.035-30.242zm0 0"/></svg>
          </span>{{label.friends}}
        </a>
      </li>
      <li v-if="settings.group_chat_enable == '1' && Object.keys(groups).length">
        <a href="javascript:void(0)" @click="currentTab = 'groups'" :class="{buc__active : currentTab == 'groups'}">
          <span class="buc__icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.999 511.999"><defs/><path d="M438.09 273.32h-39.596c4.036 11.05 6.241 22.975 6.241 35.404v149.65c0 5.182-.902 10.156-2.543 14.782h65.461c24.453 0 44.346-19.894 44.346-44.346v-81.581c.001-40.753-33.155-73.909-73.909-73.909zM107.265 308.725c0-12.43 2.205-24.354 6.241-35.404H73.91c-40.754 0-73.91 33.156-73.91 73.91v81.581c0 24.452 19.893 44.346 44.346 44.346h65.462a44.144 44.144 0 01-2.543-14.783v-149.65zM301.261 234.815h-90.522c-40.754 0-73.91 33.156-73.91 73.91v149.65c0 8.163 6.618 14.782 14.782 14.782h208.778c8.164 0 14.782-6.618 14.782-14.782v-149.65c0-40.754-33.156-73.91-73.91-73.91zM256 38.84c-49.012 0-88.886 39.874-88.886 88.887 0 33.245 18.349 62.28 45.447 77.524 12.853 7.23 27.671 11.362 43.439 11.362s30.586-4.132 43.439-11.362c27.099-15.244 45.447-44.28 45.447-77.524 0-49.012-39.874-88.887-88.886-88.887zM99.918 121.689c-36.655 0-66.475 29.82-66.475 66.475 0 36.655 29.82 66.475 66.475 66.475a66.095 66.095 0 0026.195-5.388c13.906-5.987 25.372-16.585 32.467-29.86a66.05 66.05 0 007.813-31.227c0-36.654-29.82-66.475-66.475-66.475zM412.082 121.689c-36.655 0-66.475 29.82-66.475 66.475a66.045 66.045 0 007.813 31.227c7.095 13.276 18.561 23.874 32.467 29.86a66.095 66.095 0 0026.195 5.388c36.655 0 66.475-29.82 66.475-66.475 0-36.655-29.82-66.475-66.475-66.475z"/></svg>
          </span>{{label.groups}}
        </a>
      </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
export default {
  name: "UsersPanel",
  data() {
    return {
      showUserMenu: false,
      showStatus: false,
      currentStatus: this.my_profile.user_status == "" ? 'online' : this.my_profile.user_status,
      profileStatusClass: this.my_profile.user_status == "" ? 'buc__online' : 'buc__' + this.my_profile.user_status,
      currentTab: this.chats.length ? 'chats' : 'friends',
      searchParam: '',
      isSoundOn: this.my_profile.sound
    };
  },
  props: {
    showChatWindow: {
      type: Function
    },
    friends: {
      type: Object
    },
    groups: {
      type: Object
    },
    chats: {
      type: Array
    }
  },
  computed: {
    /** Filter on search */
    filteredFriend() {
      if(this.searchParam) {
        return Object.keys(this.friends)
        .map(key => this.friends[key])
        .filter(friend => {
          return friend.fullname.toLowerCase().includes(this.searchParam.toLowerCase())
        })
      }else {
        return this.friends;
      }
    },
    filteredGroup() {
      if(this.searchParam) {
        return Object.keys(this.groups)
        .map(key => this.groups[key])
        .filter(group => {
          return group.group_name.toLowerCase().includes(this.searchParam.toLowerCase())
        })
      }else {
        return this.groups;
      }
    },
    filteredChats() {
      if(this.searchParam) {
        return this.chats.filter(chat => {
          return chat.fullname.toLowerCase().includes(this.searchParam.toLowerCase())
        })
      }else {
        return this.chats;
      }
    }
  },
  methods: {
    onChatOpen(id, isGroup) {
      if(isGroup == 1 && Object.keys(this.groups[id].group_join).length && this.groups[id].group_join.id == "join_group") {
        alert('Please join the group to start the conversation.');
        return;
      }
      this.$emit("showChatWindow", id, isGroup);
    },
    hideStatusTray() {
      if (this.showStatus) this.showStatus = false; //on outside click hide tray
    },
    /** Show status away / offline according to admin settings and interval */
    resolveStatus(ind) {
      if(this.friends[ind].user_status == 'online') {
        let lastSeen = new Date(this.friends[ind].last_active);
        let timeNowObj = new Date().toUTCString().split(' ').slice(0, 5).join(' ');
        let timeNow = new Date(timeNowObj);
        let diffInMilliSeconds = Math.abs(timeNow - lastSeen) / 1000;
        const minutes = Math.floor(diffInMilliSeconds / 60);
        if(minutes > this.settings.chat_interval_away && minutes < this.settings.chat_interval_offline) {
          return 'away';
        }else if(minutes > this.settings.chat_interval_offline) {
          return 'offline';
        } else {
          return 'online';
        }
      }else {        
        return this.friends[ind].user_status;
      }
    },
    setStatus(newStatus) {      
      if(this.currentStatus == newStatus) return;
      this.$api
      .get("", {
        params: {
          action: 'buc_set_user_status',
          status: newStatus
          }
      }).then(() => {       
        this.my_profile.user_status = newStatus;
        this.currentStatus = newStatus;
        this.profileStatusClass = 'buc__' + newStatus;
      })
      .catch(err => console.log(err));
    },
    toggleSound(e) {
      this.$api.get("", {
        params: {
          action: 'buc_set_user_sound_notification',
          enable: e.target.checked ? 1 : 0
        }})
      .then(res => {
        if(res.data.success)
        this.my_profile.sound = e.target.checked;
      })
      .catch(err => {console.log(err)});
    }
  },
  directives: {
    ClickOutside
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#buc__users-panel {
    z-index: 9999999;
    position: fixed;
    width: 300px;
    height: 400px;
    max-height: 450px;
    bottom: 0;
    right: 70px;
    background: var(--buc-primary-color);
    color: var(--buc-primary-text);
    overflow: hidden;
    -webkit-box-shadow: 0 4px 8px 1px rgba(43,43,43,.15);
    -o-box-shadow: 0 4px 8px 1px rgba(43,43,43,.15);
    -ms-box-shadow: 0 4px 8px 1px rgba(43,43,43,.15);
    box-shadow: 0 4px 8px 1px rgba(43,43,43,.15)
}

@media only screen and (max-width:370px) {
    #buc__users-panel {
        width: calc(100% - 70px)
    }
}

#buc__users-panel #buc__my-profile-cont {
    margin: 10px 10px 0
}

#buc__users-panel #buc__my-profile-cont .buc__wrap {
    height: 60px;
    overflow: hidden;
    -o-transition: .3s height ease;
    -webkit-transition: .3s height ease;
    transition: .3s height ease
}

#buc__users-panel #buc__my-profile-cont .buc__wrap img {
    width: 50px;
    border-radius: 50%;
    padding: 3px;
    height: auto;
    float: left;
    cursor: pointer;
    -o-transition: .3s border ease;
    -webkit-transition: .3s border ease;
    transition: .3s border ease
}

#buc__users-panel #buc__my-profile-cont .buc__wrap img.buc__online {
    border: 2px solid var(--buc-status-online)
}

#buc__users-panel #buc__my-profile-cont .buc__wrap img.buc__away {
    border: 2px solid var(--buc-status-away)
}

#buc__users-panel #buc__my-profile-cont .buc__wrap img.buc__busy {
    border: 2px solid var(--buc-status-busy)
}

#buc__users-panel #buc__my-profile-cont .buc__wrap img.buc__offline {
    border: 2px solid var(--buc-status-offline)
}

#buc__users-panel #buc__my-profile-cont .buc__wrap .buc__my-info {
    float: left;
    margin: 10px 15px;
    text-transform: capitalize
}

#buc__users-panel #buc__my-profile-cont .buc__wrap .buc__my-info p {
    line-height: 1.2
}

#buc__users-panel .buc__italic {
    font-style: italic;
    font-size: .8em
}

#buc__users-panel #buc__my-profile-cont .buc__wrap .buc__icon {
    margin-top: 10px
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__user-settings {
    position: absolute;
    line-height: initial;
    border-radius: 3px;
    z-index: 9;
    background: var(--buc-secondary-bg);
    color: var(--buc-secondary-text);
    -webkit-box-shadow: 0 3px 6px rgba(0,0,0,.1),0 3px 6px rgba(0,0,0,.2);
    box-shadow: 0 3px 6px rgba(0,0,0,.1),0 3px 6px rgba(0,0,0,.2);
    top: 40px;
    right: 20px;
    font-size: .9em
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__user-settings ul li {
    cursor: pointer;
    padding: 7px 15px
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__user-settings .buc__sound-checkbox {
    display: block;
    position: relative;
    padding-left: 25px;
    cursor: pointer;
    font-size: .9em;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__user-settings .buc__sound-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__user-settings .buc__sound-checkbox .buc__sound-checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 15px;
    width: 15px;
    background-color: #eee
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__user-settings .buc__sound-checkbox .buc__sound-checkmark:after {
    content: "";
    position: absolute;
    display: none;
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid var(--buc-primary-text);
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg)
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__user-settings ul li:hover .buc__sound-checkmark {
    background-color: #ccc
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__user-settings .buc__sound-checkbox input:checked~.buc__sound-checkmark {
    background-color: var(--buc-primary-color)
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__user-settings .buc__sound-checkbox input:checked~.buc__sound-checkmark:after {
    display: block
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options {
    position: absolute;
    opacity: 0;
    visibility: hidden;
    top: 70px;
    border-radius: 3px;
    z-index: 9;
    background: var(--buc-primary-hover);
    -webkit-box-shadow: 0 3px 6px rgba(0,0,0,.1),0 3px 6px rgba(0,0,0,.2);
    box-shadow: 0 3px 6px rgba(0,0,0,.1),0 3px 6px rgba(0,0,0,.2);
    -o-transition: .3s all ease;
    -webkit-transition: .3s all ease;
    transition: .3s all ease;
    font-size: .9em
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options:before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 8px solid var(--buc-primary-hover);
    top: -8px;
    left: 18px
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options.buc__active {
    opacity: 1;
    visibility: visible
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options ul {
    overflow: hidden;
    border-radius: 6px
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options ul li {
    padding: 7px 20px 7px 10px;
    display: block;
    cursor: pointer
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options ul li:hover {
    background: rgba(0,0,0,.15)
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options ul p {
    margin-left: 20px
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options ul li span.buc__status-circle {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 3px 0 0
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options ul li span.buc__status-circle:before {
    content: "";
    position: absolute;
    width: 14px;
    height: 14px;
    margin: -2px 0 0 -2px;
    background: 0 0;
    border-radius: 50%
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options ul li#buc__status-online span.buc__status-circle {
    background: var(--buc-status-online)
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options ul li#buc__status-online.buc__active span.buc__status-circle:before {
    border: 1px solid var(--buc-status-online)
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options ul li#buc__status-away span.buc__status-circle {
    background: var(--buc-status-away)
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options ul li#buc__status-away.buc__active span.buc__status-circle:before {
    border: 1px solid var(--buc-status-away)
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options ul li#buc__status-busy span.buc__status-circle {
    background: var(--buc-status-busy)
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options ul li#buc__status-busy.buc__active span.buc__status-circle:before {
    border: 1px solid var(--buc-status-busy)
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options ul li#buc__status-offline span.buc__status-circle {
    background: var(--buc-status-offline)
}

#buc__users-panel #buc__my-profile-cont .buc__wrap #buc__status-options ul li#buc__status-offline.buc__active span.buc__status-circle:before {
    border: 1px solid var(--buc-status-offline)
}

#buc__users-panel #buc__user-search {
    border-bottom: 1px solid var(--buc-primary-color);
    font-weight: 300
}

#buc__users-panel #buc__user-search label {
    position: absolute;
    margin: 10px 0 0 20px
}

#buc__users-panel #buc__user-search input {
    font-family: "proxima-nova","Source Sans Pro",sans-serif;
    padding: 10px 0 10px 46px;
    width: 100%;
    border: 0;
    background: var(--buc-primary-shade);
    color: var(--buc-primary-text)
}

#buc__users-panel #buc__user-search input:focus {
    outline: 0;
    background: var(--buc-primary-hover)
}

#buc__users-panel #buc__user-search input::-webkit-input-placeholder {
    color: var(--buc-primary-text)
}

#buc__users-panel #buc__user-search input::-moz-placeholder {
    color: var(--buc-primary-text)
}

#buc__users-panel #buc__user-search input:-ms-input-placeholder {
    color: var(--buc-primary-text)
}

#buc__users-panel #buc__user-search input:-moz-placeholder {
    color: var(--buc-primary-text)
}

#buc__users-panel #buc__empty-user-cont {
    height: 100%;
    color: rgba(255,255,255,.1);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
}

#buc__users-panel #buc__empty-user-cont svg {
    fill: currentColor;
    width: 70px;
    margin-bottom: 20px
}

#buc__users-panel #buc__contacts-cont {
    height: calc(100% - 145px);
    width: 100%;
    overflow-y: auto;
    -ms-scroll-chaining: none;
    overscroll-behavior: contain;
    overflow-x: hidden
}

#buc__users-panel #buc__contacts-cont ul li.buc__contacts-list {
    position: relative;
    padding: 10px 0 15px;
    font-size: .9em;
    cursor: pointer
}

#buc__users-panel #buc__contacts-cont ul li.buc__contacts-list.buc__active,#buc__users-panel #buc__contacts-cont ul li.buc__contacts-list:hover {
    background: var(--buc-primary-shade)
}

#buc__users-panel #buc__contacts-cont ul li.buc__contacts-list.buc__active span.buc__contact-status {
    border: 2px solid var(--buc-primary-shade)!important
}

#buc__users-panel #buc__contacts-cont ul li.buc__contacts-list .buc__wrap {
    width: 88%;
    margin: 0 auto;
    position: relative
}

#buc__users-panel #buc__contacts-cont ul li.buc__contacts-list .buc__wrap .buc__contact-status {
    position: absolute;
    left: 0;
    margin: -1px 0 0 -1px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid var(--buc-primary-color);
    background: var(--buc-status-offline)
}

#buc__users-panel #buc__contacts-cont ul li.buc__contacts-list .buc__contact-status.online {
    background: var(--buc-status-online)
}

#buc__users-panel #buc__contacts-cont ul li.buc__contacts-list .buc__contact-status.away {
    background: var(--buc-status-away)
}

#buc__users-panel #buc__contacts-cont ul li.buc__contacts-list .buc__contact-status.busy {
    background: var(--buc-status-busy)
}

#buc__users-panel #buc__contacts-cont ul li.buc__contacts-list .buc__wrap img {
    width: 40px;
    border-radius: 50%;
    float: left;
    margin-right: 10px
}

#buc__users-panel #buc__contacts-cont ul li.buc__contacts-list .buc__wrap .buc__contact-info {
    padding: 5px 0 0
}

#buc__users-panel #buc__contacts-cont ul li.buc__contacts-list .buc__wrap .buc__contact-info .buc__group-button {
    position: absolute;
    top: calc(50% - 10px);
    right: 0;
    padding: 3px 7px;
    border: 1px solid var(--buc-primary-text);
    border-radius: 3px;
    font-size: .8em
}

#buc__users-panel #buc__contacts-cont ul li.buc__contacts-list .buc__wrap .buc__contact-info .buc__contact-name {
    white-space: nowrap;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    overflow: hidden;
    font-weight: 600;
    max-width: 140px
}

#buc__users-panel #buc__contacts-cont ul li.buc__contacts-list .buc__wrap .buc__contact-info .buc__contact-last-msg {
    display: block;
    margin: 5px 0 0;
    padding: 0 0 1px;
    white-space: nowrap;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    -o-transition: 1s all ease;
    -webkit-transition: 1s all ease;
    transition: 1s all ease
}

#buc__users-panel #buc__contacts-cont ul li.buc__contacts-list .buc__wrap .buc__contact-info .buc__unread-count {
    top: 50%;
    right: 0
}

#buc__users-panel .buc__nav-bar {
    position: absolute;
    width: 100%;
    bottom: 0;
    text-align: center
}

#buc__users-panel .buc__nav-bar ul {
    display: table;
    table-layout: fixed;
    width: 100%
}

#buc__users-panel .buc__nav-bar ul li {
    display: table-cell
}

#buc__users-panel .buc__nav-bar ul li a {
    float: left;
    border: 0;
    width: 100%;
    padding: 10px 0;
    background: var(--buc-primary-shade);
    cursor: pointer;
    font-size: .85em;
    font-family: "proxima-nova","Source Sans Pro",sans-serif
}

#buc__users-panel .buc__nav-bar li a:focus {
    outline: 0
}

#buc__users-panel .buc__nav-bar li:nth-child(n+2) a {
    border-left: 1px solid var(--buc-primary-color)
}

#buc__users-panel .buc__nav-bar li a.buc__active,#buc__users-panel .buc__nav-bar li a:hover {
    background: var(--buc-primary-hover)
}
</style>
